/**
 * @generated SignedSource<<832611088ab4db3452998e2a98440247>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateNotificationRuleRootQuery$variables = Record<PropertyKey, never>;
export type CreateNotificationRuleRootQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CreateNotificationRuleHeader_query" | "NotificationsSettingsPage_query">;
};
export type CreateNotificationRuleRootQuery = {
  response: CreateNotificationRuleRootQuery$data;
  variables: CreateNotificationRuleRootQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateNotificationRuleRootQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CreateNotificationRuleHeader_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "NotificationsSettingsPage_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CreateNotificationRuleRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "JiraInstanceConnection",
        "kind": "LinkedField",
        "name": "jiraInstances",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "whoami",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlConfig",
            "kind": "LinkedField",
            "name": "UrlConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "docs",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4f185df3d0fd21b6f641311d7a8cd3ed",
    "id": null,
    "metadata": {},
    "name": "CreateNotificationRuleRootQuery",
    "operationKind": "query",
    "text": "query CreateNotificationRuleRootQuery {\n  ...CreateNotificationRuleHeader_query\n  ...NotificationsSettingsPage_query\n}\n\nfragment BreadCrumbsHeader_query on Query {\n  whoami {\n    email\n    displayName\n  }\n}\n\nfragment CreateNotificationRuleHeader_query on Query {\n  jiraInstances {\n    pageInfo {\n      total\n    }\n  }\n}\n\nfragment NotificationsSettingsPage_query on Query {\n  ...PageWithBreadCrumbs_query\n}\n\nfragment PageWithBreadCrumbs_query on Query {\n  ...BreadCrumbsHeader_query\n}\n"
  }
};

(node as any).hash = "88059457129fcf19dd01a726e8f690ed";

export default node;
